import "knockout";
import register from "flow/knockout/register";

register.registerKnockoutExtension("logChange", function (target: KnockoutObservable<any>, option: string) {
    target.subscribe(newValue => {
        console.log(`${option}:`, newValue);
    });
    return target;
});
